import { getCategoryInfo } from '@utils/helpers';

const CategoryBadge = ({ category, size = 'sm' }) => {
  const info = getCategoryInfo(category);
  const sizeClasses = size === 'sm' ? 'px-2.5 py-1 text-[11px]' : 'px-3 py-1.5 text-xs';

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-xl font-semibold ${info.color} ${sizeClasses}`}>
      <span>{info.emoji}</span>
      <span>{info.label}</span>
    </span>
  );
};

export default CategoryBadge;
